import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { MessagesService } from '../../common/services/messages.service';

@Injectable()
export class MessagesResolverService implements Resolve<Promise<any>> {
  constructor(private service: MessagesService) { }

  resolve() {
    return this.service.sessions().toPromise().then( data => {
      return data;
    });
  }
}
